interface ImageDimensions {
  width: number;
  height: number;
}
interface DiscoveryImageDimensionsMap {
  [key: string]: ImageDimensions;
}

const scaleDimensions = (dimensions: ImageDimensions, scale: number = 3): ImageDimensions => {
  return {
    width: Math.round(dimensions.width / scale),
    height: Math.round(dimensions.height / scale),
  };
};

export const uploadDimensions: DiscoveryImageDimensionsMap = {
  legacyMobileBanner: { width: 414, height: 90 },
  legacyDesktopBanner: { width: 1300, height: 150 },
  mobileBanner: { width: 3200, height: 800 },
  desktopBanner: { width: 3200, height: 400 },
  spotlight: { width: 2520, height: 1420 },
  browseBy: { width: 600, height: 600 },
  contentBlock: { width: 1080, height: 1080 },
  miniStory: { width: 2520, height: 1420 },
  recipeCard: { width: 3000, height: 1294 },
  actionBar: { width: 100, height: 100 },
};

const renderDimensions: DiscoveryImageDimensionsMap = {
  mobileBanner: uploadDimensions.mobileBanner,
  desktopBanner: uploadDimensions.desktopBanner,
  legacyMobileBanner: uploadDimensions.legacyMobileBanner,
  legacyDesktopBanner: uploadDimensions.legacyDesktopBanner,
  spotlight: scaleDimensions(uploadDimensions.spotlight),
  browseBy: scaleDimensions(uploadDimensions.browseBy),
  contentBlock: scaleDimensions(uploadDimensions.contentBlock),
  miniStory: scaleDimensions(uploadDimensions.miniStory),
  recipeCard: scaleDimensions(uploadDimensions.recipeCard),
  actionBar: scaleDimensions(uploadDimensions.actionBar),
};

const renderCloudinaryParams = (dimensions: ImageDimensions): string => {
  return `c_scale,w_${dimensions.width},h_${dimensions.height},dpr_2.0/f_jpg`;
};

export const cloudinaryParams = {
  legacyMobileBanner: renderCloudinaryParams(renderDimensions.legacyMobileBanner),
  legacyDesktopBanner: renderCloudinaryParams(renderDimensions.legacyDesktopBanner),
  mobileBanner: renderCloudinaryParams(renderDimensions.mobileBanner),
  desktopBanner: renderCloudinaryParams(renderDimensions.desktopBanner),
  spotlight: renderCloudinaryParams(renderDimensions.spotlight),
  browseBy: renderCloudinaryParams(renderDimensions.browseBy),
  contentBlock: renderCloudinaryParams(renderDimensions.contentBlock),
  miniStory: renderCloudinaryParams(renderDimensions.miniStory),
  recipeCard: renderCloudinaryParams(renderDimensions.recipeCard),
  actionBar: renderCloudinaryParams(renderDimensions.actionBar),
};
